(function () {
  var page = document.querySelector('[data-ghost-shop-page]');
  if (!page) return;

  var catalog = page.querySelector('[data-ghost-shop-catalog]');
  var filterButtons = page.querySelectorAll('[data-ghost-shop-filter]');
  var groups = page.querySelectorAll('[data-shop-group]');
  var cartVariantIds = new Set();

  var lightbox = page.querySelector('[data-ghost-shop-lightbox]');
  var lightboxImage = page.querySelector('[data-ghost-shop-lightbox-image]');
  var lightboxCounter = page.querySelector('[data-ghost-shop-lightbox-counter]');
  var lightboxThumbs = page.querySelector('[data-ghost-shop-lightbox-thumbs]');
  var lightboxClose = page.querySelector('[data-ghost-shop-lightbox-close]');
  var lightboxPrev = page.querySelector('[data-ghost-shop-lightbox-prev]');
  var lightboxNext = page.querySelector('[data-ghost-shop-lightbox-next]');

  var lightboxImages = [];
  var lightboxIndex = 0;
  var focus = window.GhostModalFocus;
  var lightboxStage = page.querySelector('[data-ghost-shop-lightbox-stage]');
  var showImageLabelTemplate = page.getAttribute('data-ghost-shop-show-image-label') || 'Show image __NUMBER__';

  function showImageLabel(index) {
    return showImageLabelTemplate.replace('__NUMBER__', String(index + 1));
  }

  function setFilter(filter) {
    page.classList.toggle('is-filter-all', filter === 'all');

    filterButtons.forEach(function (button) {
      var isActive = button.getAttribute('data-ghost-shop-filter') === filter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    groups.forEach(function (group) {
      if (filter === 'all') {
        group.hidden = false;
        return;
      }
      group.hidden = group.getAttribute('data-shop-group') !== filter;
    });
  }

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setFilter(button.getAttribute('data-ghost-shop-filter') || 'all');
    });
  });

  function getActiveVariantButton(card) {
    return card.querySelector('[data-ghost-catalog-variant].is-active')
      || card.querySelector('[data-ghost-catalog-variant]');
  }

  function bindCatalogThumb(card, thumb) {
    thumb.addEventListener('click', function (event) {
      event.stopPropagation();
      var imageNode = card.querySelector('[data-ghost-catalog-image]');
      var imageUrl = thumb.getAttribute('data-image-url');
      if (!imageNode || !imageUrl) return;

      card.querySelectorAll('[data-ghost-catalog-thumb]').forEach(function (item) {
        item.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      imageNode.src = imageUrl;
      imageNode.srcset = '';
    });
  }

  function thumbUrlFromFull(url) {
    if (!url) return url;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      return url.replace(/width=\d+/i, 'width=240').replace(/_\d+x(\.|$)/, '_240x$1');
    }
    return url;
  }

  function updateCardGallery(card, urls) {
    if (!Array.isArray(urls) || !urls.length) return;

    var galleryNode = card.querySelector('[data-ghost-catalog-gallery]');
    if (galleryNode) {
      galleryNode.textContent = JSON.stringify(urls);
    }

    var thumbsWrap = card.querySelector('[data-ghost-catalog-thumbs]');
    if (urls.length > 1) {
      if (!thumbsWrap) {
        var media = card.querySelector('[data-ghost-catalog-lightbox-trigger]');
        if (!media) return;
        thumbsWrap = document.createElement('div');
        thumbsWrap.className = 'ghost-catalog-card__thumbs';
        thumbsWrap.setAttribute('data-ghost-catalog-thumbs', '');
        media.appendChild(thumbsWrap);
      }

      thumbsWrap.hidden = false;
      thumbsWrap.innerHTML = '';

      urls.slice(0, 5).forEach(function (url, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ghost-catalog-card__thumb' + (index === 0 ? ' is-active' : '');
        button.setAttribute('data-ghost-catalog-thumb', '');
        button.setAttribute('data-image-url', url);
        button.setAttribute('aria-label', showImageLabel(index));
        button.innerHTML = '<img src="' + thumbUrlFromFull(url).replace(/"/g, '&quot;') + '" alt="" width="36" height="36" loading="lazy">';
        bindCatalogThumb(card, button);
        thumbsWrap.appendChild(button);
      });
    } else if (thumbsWrap) {
      thumbsWrap.hidden = true;
    }

    var imageNode = card.querySelector('[data-ghost-catalog-image]');
    if (imageNode && urls[0]) {
      imageNode.src = urls[0];
      imageNode.srcset = '';
    }
  }

  function updateBuyButton(card) {
    var buyButton = card.querySelector('[data-ghost-catalog-buy]');
    var variantInput = card.querySelector('[data-ghost-catalog-variant-input]');
    if (!buyButton || !variantInput) return;

    var activeVariant = getActiveVariantButton(card);
    var variantId = String(variantInput.value || '');
    var labelAvailable = buyButton.getAttribute('data-label-available') || 'Add to cart';
    var labelInCart = buyButton.getAttribute('data-label-in-cart') || 'Already in your cart';
    var labelSoldOut = buyButton.getAttribute('data-label-sold-out') || 'Sold out';
    var variantAvailable = buyButton.getAttribute('data-variant-available') !== 'false';
    var inCart = variantId && cartVariantIds.has(variantId);

    if (!variantAvailable || !variantId) {
      buyButton.disabled = true;
      buyButton.textContent = labelSoldOut;
      buyButton.classList.remove('is-in-cart');
      return;
    }

    if (activeVariant && activeVariant.getAttribute('data-available') === 'false') {
      buyButton.disabled = true;
      buyButton.textContent = labelSoldOut;
      buyButton.classList.remove('is-in-cart');
      return;
    }

    buyButton.disabled = false;

    if (inCart) {
      buyButton.textContent = labelInCart;
      buyButton.classList.add('is-in-cart');
      return;
    }

    buyButton.textContent = labelAvailable;
    buyButton.classList.remove('is-in-cart');
  }

  function syncCartVariants(cart) {
    cartVariantIds.clear();

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        cartVariantIds.add(String(item.variant_id));
      });
    }

    page.querySelectorAll('[data-ghost-catalog-card]').forEach(updateBuyButton);
  }

  function updateVariantCopy(card, button) {
    if (!button.hasAttribute('data-variant-copy')) {
      return;
    }

    var titleNode = card.querySelector('[data-ghost-catalog-title]');
    var descriptionNode = card.querySelector('[data-ghost-catalog-description]');
    var specsNode = card.querySelector('[data-ghost-catalog-specs]');
    var specIndex;
    var specs = [];

    if (titleNode) {
      titleNode.textContent = button.getAttribute('data-variant-display-name') || '';
    }

    if (descriptionNode) {
      var description = button.getAttribute('data-variant-description') || '';
      descriptionNode.textContent = description;

      if (description) {
        descriptionNode.classList.remove('ghost-catalog-card__description--empty');
        descriptionNode.removeAttribute('aria-hidden');
      } else {
        descriptionNode.classList.add('ghost-catalog-card__description--empty');
        descriptionNode.setAttribute('aria-hidden', 'true');
      }
    }

    for (specIndex = 1; specIndex <= 5; specIndex += 1) {
      var specValue = button.getAttribute('data-variant-spec-' + specIndex);
      if (specValue) {
        specs.push(specValue);
      }
    }

    if (specsNode) {
      var headingNode = specsNode.querySelector('[data-ghost-catalog-specs-heading]');

      specsNode.querySelectorAll('li:not([data-ghost-catalog-specs-heading])').forEach(function (item) {
        item.remove();
      });

      specs.forEach(function (spec) {
        var item = document.createElement('li');
        item.innerHTML = '<svg width="11" height="11" viewBox="0 0 13 13" fill="none" aria-hidden="true"><path d="M1.5 6.5L4.8 9.8L11.5 3" stroke="#B22234" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
        item.querySelector('span').textContent = spec;
        specsNode.appendChild(item);
      });

      if (specs.length === 0 && !headingNode) {
        specsNode.hidden = true;
      } else {
        specsNode.hidden = false;
      }
    }
  }

  function selectVariant(card, button) {
    var variantButtons = card.querySelectorAll('[data-ghost-catalog-variant]');
    var variantInput = card.querySelector('[data-ghost-catalog-variant-input]');
    var priceNode = card.querySelector('[data-ghost-catalog-price]');
    var compareNode = card.querySelector('[data-ghost-catalog-compare]');
    var compareInput = card.querySelector('[data-ghost-catalog-compare-input]');
    var imageNode = card.querySelector('[data-ghost-catalog-image]');

    variantButtons.forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-pressed', 'false');
    });

    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');

    if (variantInput) {
      variantInput.value = button.getAttribute('data-variant-id') || '';
    }

    if (compareInput) {
      compareInput.value = button.getAttribute('data-compare-at-cents') || '';
    }

    if (priceNode) {
      priceNode.textContent = button.getAttribute('data-price') || '';
    }

    if (compareNode) {
      var comparePrice = button.getAttribute('data-compare-price');
      if (comparePrice) {
        compareNode.textContent = comparePrice;
        compareNode.hidden = false;
      } else {
        compareNode.textContent = '';
        compareNode.hidden = true;
      }
    }

    updateBuyButton(card);

    if (imageNode) {
      var imageUrl = button.getAttribute('data-image-url');
      if (imageUrl) {
        imageNode.src = imageUrl;
        imageNode.srcset = '';
      }
    }

    var galleryData = button.getAttribute('data-gallery-urls');
    if (galleryData) {
      try {
        updateCardGallery(card, JSON.parse(galleryData));
      } catch (error) {}
    }

    updateVariantCopy(card, button);
  }

  page.querySelectorAll('[data-ghost-catalog-card]').forEach(function (card) {
    card.querySelectorAll('[data-ghost-catalog-variant]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        if (button.classList.contains('ghost-catalog-card__variant--solo')) return;
        selectVariant(card, button);
      });
    });

    var soloVariant = card.querySelector('[data-ghost-catalog-variant].ghost-catalog-card__variant--solo');
    if (soloVariant && !soloVariant.classList.contains('ghost-catalog-card__variant--pack')) {
      selectVariant(card, soloVariant);
    }

    card.querySelectorAll('[data-ghost-catalog-thumb]').forEach(function (thumb) {
      bindCatalogThumb(card, thumb);
    });

    var media = card.querySelector('[data-ghost-catalog-lightbox-trigger]');
    if (media) {
      media.addEventListener('click', function (event) {
        if (event.target.closest('[data-ghost-catalog-thumb]')) return;
        openLightbox(card);
      });
      media.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openLightbox(card);
        }
      });
    }
  });

  function parseGallery(card) {
    var node = card.querySelector('[data-ghost-catalog-gallery]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function renderLightboxThumbs() {
    if (!lightboxThumbs) return;
    lightboxThumbs.innerHTML = '';

    lightboxImages.forEach(function (url, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = index === lightboxIndex ? 'is-active' : '';
      button.setAttribute('aria-label', showImageLabel(index));
      button.innerHTML = '<img src="' + thumbUrlFromFull(url).replace(/"/g, '&quot;') + '" alt="">';
      button.addEventListener('click', function () {
        lightboxIndex = index;
        updateLightbox();
      });
      lightboxThumbs.appendChild(button);
    });
  }

  function updateLightbox() {
    if (!lightboxImage || !lightboxImages.length) return;
    lightboxImage.src = lightboxImages[lightboxIndex];
    if (lightboxCounter) {
      lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxImages.length;
    }
    renderLightboxThumbs();
    if (lightboxPrev) lightboxPrev.hidden = lightboxImages.length <= 1;
    if (lightboxNext) lightboxNext.hidden = lightboxImages.length <= 1;
  }

  function openLightbox(card) {
    lightboxImages = parseGallery(card);
    if (!lightboxImages.length) {
      var imageNode = card.querySelector('[data-ghost-catalog-image]');
      if (imageNode && imageNode.src) {
        lightboxImages = [imageNode.src];
      }
    }
    if (!lightboxImages.length || !lightbox) return;

    var activeThumb = card.querySelector('[data-ghost-catalog-thumb].is-active');
    lightboxIndex = 0;
    if (activeThumb) {
      var activeUrl = activeThumb.getAttribute('data-image-url');
      var matchIndex = lightboxImages.indexOf(activeUrl);
      if (matchIndex >= 0) lightboxIndex = matchIndex;
    }

    updateLightbox();
    if (focus) focus.rememberFocus();
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (focus) focus.focusInitial(lightboxStage || lightbox, '[data-ghost-shop-lightbox-close]');
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (focus) focus.restoreFocus();
  }

  function stepLightbox(delta) {
    if (!lightboxImages.length) return;
    lightboxIndex = (lightboxIndex + delta + lightboxImages.length) % lightboxImages.length;
    updateLightbox();
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function () { stepLightbox(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function () { stepLightbox(1); });
  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!lightbox || lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') stepLightbox(-1);
    if (event.key === 'ArrowRight') stepLightbox(1);
    if (focus) focus.trapTab(event, lightboxStage || lightbox);
  });

  document.addEventListener('ghost:cart:updated', function (event) {
    syncCartVariants(event.detail && event.detail.cart ? event.detail.cart : null);
  });

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(syncCartVariants)
    .catch(function () {});

  setFilter('all');
})();
